import { TableColumn } from '../../../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { ConfinedSpaceAlternateEntryForm } from './confined-space-alt-entry.model';

export class ConfinedSpaceAlternateEntryFormListItem {
  /** When the form was submitted ("Entry Date" column) */
  submissionDate: Date | null = null;

  /** The person who submitted the form ("User" column) */
  submittedByName: string | null = null;

  /** Location of the space */
  spaceLocation: string | null = null;

  /** Entry date */
  entryDate: string | null = null;

  /** Entry duration */
  entryDuration: string | null = null;

  /** Whether forced air ventilation is required */
  forcedAirVentilationRequired: string | null = null;

  /** Type of ventilation */
  ventilationType: string | null = null;


  id: string = '';

  constructor(data?: Partial<ConfinedSpaceAlternateEntryFormListItem>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static getTableColumns(): TableColumn[] {
    const columns: TableColumn[] = [];
    const instance = new ConfinedSpaceAlternateEntryFormListItem();
    const fieldMappings = ConfinedSpaceAlternateEntryForm.getFieldMappings();
    
    // Get all properties of the class
    Object.keys(instance).forEach(key => {
      // Skip the id property as it's handled separately
      if (key === 'id') return;

      // Determine the type based on the property value
      let type: 'text' | 'date' | 'action' | 'status' = 'text';
      const value = instance[key as keyof ConfinedSpaceAlternateEntryFormListItem];
      
      if (value instanceof Date || (value === null && key.toLowerCase().includes('date'))) {
        type = 'date';
      }
      // All other values default to 'text' type

      // Add the column if it has a mapping
      if (fieldMappings[key]) {
        columns.push({
          key,
          label: fieldMappings[key],
          type,
          sortable: true
        });
      }
    });

    

    return columns;
  }

  static fromApiResponse(data: any): ConfinedSpaceAlternateEntryFormListItem {
    return new ConfinedSpaceAlternateEntryFormListItem({
      id: data.id,
      submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
      submittedByName: data.submittedByName,
      spaceLocation: data.spaceLocation,
      entryDate: data.entryDate,
      entryDuration: data.entryDuration,
      forcedAirVentilationRequired: data.forcedAirVentilationRequired,
      ventilationType: data.ventilationType,
    });
  }
} 